module.exports = __webpack_public_path__ + "static/media/Logo_small@2x.0292a572.png";